<template>
<div>
  <b-container fluid>
    <b-row>
      <b-col cols="12">
        <b-card no-body
                :header="DisplayPersonal" header-bg-variant="dark" header-text-variant="light">
            <b-list-group flush>
                <b-list-group-item>Id: {{ListaLicenciaCargoPersonalSeleccionado}}</b-list-group-item>
            </b-list-group>
        </b-card>
      </b-col>
    </b-row>
    <hr/>
    <b-row>
      <b-col cols="12">
        <validation-observer ref="observer" v-slot="{ handleSubmit }">
          <b-form v-if="true" enctype="multipart/form-data" @submit.stop.prevent="handleSubmit(onSubmit)">
            <b-form-row v-if="notEmptyObject(this)">
              <b-col cols="12">
                <card-datos-contacto :personal="this.personal"></card-datos-contacto>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col cols="6">
                <validation-provider name="fechaAltamedica" :rules="{ required: true }" v-slot="validationContext">
                  <b-form-group id="inputFechaAltamedica-group" label="Fecha Alta Medica" label-for="inputFechaAltamedica">
                    <b-form-datepicker
                      locale="es"
                      id="inputFechaAltamedica"
                      v-model="inputFechaAltamedica.value"
                      placeholder="Alta Medica"
                      :disabled="disabled"
                      :min="inputFechaAltamedica.min"
                      :max="inputFechaAltamedica.max"
                      :state="checkForm(validationContext)"
                    ></b-form-datepicker>
                    <b-form-invalid-feedback id="inputFechaAltamedica-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="6">
                <validation-provider name="fechaReingresoLaboral" :rules="{ required: true }" v-slot="validationContext">
                  <b-form-group id="inputFechaReingresoLaboral-group" label="Fecha de Reingreso" label-for="inputFechaReingresoLaboral">
                    <b-form-datepicker
                      locale="es"
                      id="inputFechaReingresoLaboral"
                      v-model="inputFechaReingresoLaboral.value"
                      placeholder="Fecha de Reingreso"
                      :disabled="disabled"
                      :min="inputFechaReingresoLaboral.min"
                      :max="inputFechaReingresoLaboral.max"
                      :state="checkForm(validationContext)"
                    ></b-form-datepicker>
                    <b-form-invalid-feedback id="inputFechaReingresoLaboral-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col cols="4">
                <validation-provider name="cambiaFunciones" :rules="{ required: false }" v-slot="validationContext">
                  <b-form-group id="inputCambiaFunciones-group" label="CambiaFunciones" label-for="inputCambiaFunciones">
                    <b-form-checkbox
                      id="inputCambiaFunciones"
                      v-model="inputCambiaFunciones"
                      :disabled="disabled"
                      :state="checkForm(validationContext)"
                      size="lg">
                      CambiaFunciones
                    </b-form-checkbox>
                    <b-form-invalid-feedback id="inputCambiaFunciones-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="4">
                <validation-provider name="adecuacionTareas" :rules="{ required: false }" v-slot="validationContext">
                  <b-form-group id="inputAdecuacionTareas-group" label="AdecuacionTareas" label-for="inputAdecuacionTareas">
                    <b-form-checkbox
                      id="inputAdecuacionTareas"
                      v-model="inputAdecuacionTareas"
                      :disabled="disabled"
                      :state="checkForm(validationContext)"
                      size="lg">
                      AdecuacionTareas
                    </b-form-checkbox>
                    <b-form-invalid-feedback id="inputAdecuacionTareas-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="4">
                <validation-provider name="reduccionHoraria" :rules="{ required: false }" v-slot="validationContext">
                  <b-form-group id="inputReduccionHoraria-group" label="ReduccionHoraria" label-for="inputReduccionHoraria">
                    <b-form-checkbox
                      id="inputReduccionHoraria"
                      v-model="inputReduccionHoraria"
                      :disabled="disabled"
                      :state="checkForm(validationContext)"
                      size="lg">
                      ReduccionHoraria
                    </b-form-checkbox>
                    <b-form-invalid-feedback id="inputReduccionHoraria-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col cols="12">
                <validation-provider v-if="true" name="observaciones" :rules="{ required: true }" v-slot="validationContext">
                <b-form-group id="inputObservaciones-group" label="Observaciones :" label-for="inputObservaciones">
                  <b-form-textarea
                    id="inputObservaciones"
                    v-model="inputObservaciones"
                    placeholder=""
                    rows="3"
                    max-rows="6"
                    :disabled="disabled"
                    :state="checkForm(validationContext)"
                  ></b-form-textarea>
                  </b-form-group>
                  <b-form-invalid-feedback id="inputCantidadDias-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                </validation-provider>

              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col>
                <validation-provider name="adjunto" :rules="{ required: false, ext: ['jpg', 'jpeg', 'jfif', 'png', 'pdf'], size: 3072 }" v-slot="validationContext">
                  <b-form-group id="inputAdjunto-group" label="Adjuntar archivo" label-for="inputAdjunto">
                    <b-form-file
                      class="mb-2"
                      v-model="inputAdjunto"
                      placeholder="Archivos permitidos: jpg, jpeg, jfif, png, pdf"
                      drop-placeholder="Suelte el archivo aquí..."
                      :state="checkForm(validationContext)"
                    ></b-form-file>
                    <b-button v-if="inputAdjunto" @click="inputAdjunto = null">Remover archivo </b-button>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col class="text-right">
                <b-button :disabled="disabled" class="mb-2" variant="warning" v-on:click="cerrarFormulario()">Cancelar</b-button>
                <b-button :disabled="disabled" class="mb-2" type="submit" variant="warning">Guardar</b-button>
              </b-col>
            </b-form-row>
          </b-form>
        </validation-observer>
      </b-col>
    </b-row>
  </b-container>
</div>
</template>

<script>
import swalerts from "@/helpers/swalerts";
import errorhandler from "@/helpers/errorhandler";
import { mapGetters,mapActions } from 'vuex'
import moment from 'moment';
import LicenciaCargoPersonalSvc from '@/services/licenciacargopersonal'
import SolicitudAltasvc from '@/services/solicitudalta'
import CardDatosContacto from '../../common/CardDatosContacto'



import { createHelpers } from 'vuex-map-fields';


function getWeekDay() {
  const hoy = new Date();
  const dayOfTheWeek = hoy.getDay();
  console.log('hoy',  hoy.getDate(), dayOfTheWeek);
  const newDate = dayOfTheWeek === 6 ? hoy.setDate(hoy.getDate() + 2) : dayOfTheWeek === 0  ? hoy.setDate(hoy.getDate() + 1) : hoy;

  console.log('getWeekDay', (new Date(newDate)).getDate());
  return new Date(newDate);
}
const { mapFields: mapFormSolicitudAltaFields } = createHelpers({
  getterType: 'FormSolicitudAltaModule/getSolicitudAltaField',
  mutationType: 'FormSolicitudAltaModule/updateSolicitudAltaField',
});
export default {
  name: "RegistrarSolicitudForm",
  mixins: [errorhandler, swalerts],
  components: { CardDatosContacto },
  computed: {
    ...mapGetters(['getEstablecimiento','isInRoleAdmin','isInRoleCoordinador','isInRoleEstablecimiento','isInRoleRecMedico']),
    ...mapFormSolicitudAltaFields(['explicacionArticulo','TipoLicencia', 'DetalleDiasLicencia', 'EstadoSolicitudMedica', 'FechaAltamedica', 'FechaReingresoLaboral', 'Observaciones', 'CantidadDias', 'ListaLicenciaCargoPersonalSeleccionado']),
    DisplayPersonal: function () {
      return (this.personal ? this.personal.InformacionPersonal ? this.personal.InformacionPersonal.DisplayDniNombre : 'NULL' : 'NULL');
    }
  },
  props: {
    personal: Object,
    licenciacargopersonal: Array
  },
  watch: {
  },
  data() {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    // 15th 6 months prior
    const minDate = new Date(today);
    minDate.setMonth(minDate.getMonth() - 6);
    minDate.setDate(15);
    // 15th in 6 months
    const maxDate = new Date(today);
    maxDate.setMonth(maxDate.getMonth() + 6);
    maxDate.setDate(15);
    return {
      disabled: false,
      inputFechaAltamedica: {
        value: getWeekDay(),
        min: minDate,
        max: maxDate
      },
      inputFechaReingresoLaboral: {
        value: getWeekDay(),
        min: minDate,
        max: maxDate
      },
      inputTipoSolicitudSelected: null,
      inputCantidadDias: null,
      inputAdjunto: null,
      inputObservaciones: null,
      inputFechaActual: null
    }
  },
  watch: {
    checkedItems(a, b) {
      this.allSelected = (this.datosDocente.length === a.length) ? true : false;
    },
  },
  mounted(){
  },
  methods: {
    // dateDisabled(ymd, date) {
    //   const weekday = date.getDay()
    //   return weekday === 0 || weekday === 6
    // },
    checkForm: function({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    onSubmit() {
      console.log('onSubmit');
      this.crearSolicitudAltaMedica();
    },

    findLicenciaCargoPersonal() {
      return LicenciaCargoPersonalSvc.findl({
        Personal_Id: this.id,
        IncluyeCargoPersonal: true,
        IncluyeUsuarioCarga: true
      });
    },


    limpiar: function() {
      this.panelDatosPersonales=false;
      this.msjCargoNoEncontrado=false;
      this.datosDocente = [];
      this.cantDiasSinTrabajar = 0;
    },

    toggleSelected() {
      this.checkedItems = this.selectAll ? this.cargosSeleccionados : [];
    },

    select() {
      if (!this.selectAll) {
        for (let i in this.datosDocente) {
          this.cargosSeleccionados.push(this.items[i].id);
        }
      }
    },

    obtenerFechaHasta() {
      var fechaRetornada = moment(this.inputFechaActual).add(this.txtCantidadDias, 'days').subtract(1, 'days').format();
      return fechaRetornada;
    },

    porcentajeDias() {
      return this.diasSinTrabajar;
    },
    cantDiasAnio() {
      return 365
    },


    crearSolicitudAltaMedica(){
      //this.desactivarBoton();
      this.disabled = true;

      this.inputFechaActual = moment();
      let formData = new FormData();
      formData.append("file", this.inputAdjunto);
      formData.append("serverpath", "solicitudlicencia");
      let filenameComprobante = this.inputAdjunto ? this.inputAdjunto.name : "";
      let comprobantename = `${moment().format("YYYYMMDDHHmmss")}_${filenameComprobante}`;
      formData.append("filename", comprobantename);
      try {
        return SolicitudAltasvc.crear({
          uploadfile: this.inputAdjunto ? true : false,
          formdata: formData,
          EstadoSolicitudAltaMedica: 1,
          FechaAltamedica: this.inputFechaAltamedica.value,
          FechaReingresoLaboral: this.inputFechaReingresoLaboral.value,
          CambiarFunciones: this.inputCambiarFunciones,
          AdecuacionTareas: this.inputAdecuacionTareas,
          ReduccionHoraria: this.inputReduccionHoraria,
          Observaciones: this.inputObservaciones,
          Personal_Id: this.personal.Id,
          unidadeducativa_id: this.getEstablecimiento.UnidadEducativa_Id,
          nivelenseñanza_id: this.getEstablecimiento.NivelEnseñanza_Id,
          UnidadAdministrativa_Id: this.getEstablecimiento.UnidadAdministrativa_Id,
          LicenciaCargoPersonal_Id: this.ListaLicenciaCargoPersonalSeleccionado,
          //tipolicencia_id: this.TipoLicencia ? this.TipoLicencia.Id : null,
          //detallediaslicencia_id: this.DetalleDiasLicencia ? this.DetalleDiasLicencia.Id : null
        }).then(r => {
          console.log('result crear', r);
          this.disabled = false;
          this.cerrarFormulario(r.data.status.mensaje);
        }).catch(e => {
          console.log('error crear', e);
          this.disabled = false;
          // Capturar el error en una variable
          this.error = e;
          this.errorHandler(e);
        });
      } catch (e) {
        console.log('error en try-catch', e);
        this.disabled = false;
        // Capturar el error en una variable
        this.error = e;
        this.errorHandler(e);
      }
    },
    cerrarFormulario(mensaje){
      this.limpiarFormulario();
      this.$emit('form-solicitud-close', mensaje);
    },
    limpiarFormulario()
    {
      this.ListaLicenciaCargoPersonalSeleccionado = null;
      this.TipoLicencia = null;
      this.DetalleDiasLicencia = null;
      this.inputCantidadDias = null;
      this.inputAdjunto = null;
      this.inputObservaciones = null;
      this.inputFechaActual = null;
      this.inputFechaAltamedica.value = new Date();
      this.inputFechaReingresoLaboral.value = new Date();

      this.inputTipoSolicitudSelected = null;
      this.inputTipoContagioSelected = null;
    },
  }
}
</script>

<style >
.invalid-feedback {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/solicitudes/RegistrarSolicitudAltaMedicaForm.vue